import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import LoadingSpinner from "../components/LoadingSpinner";
import { useAuthStatus, AuthStatus } from "../hooks/useAuthStatus";

/**
 * PrivateRoute - Protects routes that require full authentication
 *
 * Only allows access for users with AuthStatus.AUTHENTICATED
 * Users still in registration are redirected to /registration
 * Unauthenticated users are redirected to landing page
 */
const PrivateRoute = ({ redirectPath = "/" }) => {
  const { status: authStatus } = useAuthStatus();
  const location = useLocation();

  // Still determining auth state - show loading
  if (authStatus === AuthStatus.LOADING) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#ffffff",
        }}
      >
        <LoadingSpinner />
      </Box>
    );
  }

  // User needs to complete registration - redirect to registration
  if (authStatus === AuthStatus.NEEDS_REGISTRATION) {
    return <Navigate to="/registration" replace />;
  }

  // Not authenticated at all - redirect to landing page
  if (authStatus === AuthStatus.UNAUTHENTICATED) {
    // Store the intended destination so we can redirect back after sign-in
    sessionStorage.setItem("redirectAfterSignIn", location.pathname);
    return <Navigate to={redirectPath} replace />;
  }

  // AuthStatus.AUTHENTICATED - allow access
  return <Outlet />;
};

export default PrivateRoute;
